const outcomes = [
  {
    icon: "ri-lightbulb-flash-line",
    title: "Greater Clarity Around Opportunities",
    desc: "Move from confusion and overwhelm to a clear, structured understanding of the opportunities most relevant to your goals and readiness.",
  },
  {
    icon: "ri-bar-chart-grouped-line",
    title: "Stronger Investor Readiness",
    desc: "Build the knowledge, confidence, and strategic foundation needed to engage with investment opportunities responsibly and effectively.",
  },
  {
    icon: "ri-compass-3-line",
    title: "Better Strategic Planning",
    desc: "Develop a clear, actionable long-term wealth-building plan that reflects your values, timeline, and cross-border aspirations.",
  },
  {
    icon: "ri-shield-check-line",
    title: "More Confident Decision-Making",
    desc: "Make financial decisions from a place of knowledge and discipline &mdash; not fear, speculation, or external pressure.",
  },
];

export default function AdvisoryOutcomes() {
  return (
    <section className="relative py-24 px-6 overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0">
        <img
          src="/assets/images/site/adv-outcomes-001-1920x900.jpg"
          alt="Nairobi Kenya cross-border advisory wealth creation"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-[#0D1F14]/75" />
      </div>

      <div className="relative z-10 max-w-[1280px] mx-auto">
        <div className="text-center max-w-2xl mx-auto mb-16">
          <span className="inline-flex items-center gap-2 text-[#C9A961] text-xs font-semibold uppercase tracking-[0.25em] mb-5">
            <span className="w-8 h-px bg-[#C9A961]" />
            Outcomes & Benefits
            <span className="w-8 h-px bg-[#C9A961]" />
          </span>
          <h2 className="font-['Cormorant_Garamond'] text-4xl md:text-5xl font-bold text-white leading-tight mb-5">
            What You Can Expect From Working With Us
          </h2>
          <p className="text-white/65 text-base leading-relaxed">
            Our advisory services are designed to create lasting, meaningful change in how you approach wealth creation &mdash; not just short-term answers.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 mb-14">
          {outcomes.map((outcome) => (
            <div
              key={outcome.title}
              className="bg-white/8 border border-white/15 rounded-lg p-7 hover:bg-white/12 transition-all duration-300 group"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-full bg-[#C9A961]/20 mb-5 group-hover:bg-[#C9A961]/30 transition-colors">
                <i className={`${outcome.icon} text-[#C9A961] text-xl`} />
              </div>
              <h3 className="font-['Cormorant_Garamond'] text-xl font-bold text-white mb-3 leading-snug">
                {outcome.title}
              </h3>
              <p className="text-white/60 text-sm leading-relaxed">{outcome.desc}</p>
            </div>
          ))}
        </div>

        {/* Access statement */}
        <div className="bg-white/8 border border-white/15 rounded-lg p-8 md:p-10 text-center max-w-3xl mx-auto">
          <div className="w-12 h-12 flex items-center justify-center rounded-full bg-[#C9A961]/20 mx-auto mb-5">
            <i className="ri-key-2-line text-[#C9A961] text-xl" />
          </div>
          <h3 className="font-['Cormorant_Garamond'] text-2xl font-bold text-white mb-3">
            Access to a Trusted Platform for Long-Term Growth
          </h3>
          <p className="text-white/65 text-sm leading-relaxed mb-6">
            Beyond individual advisory sessions, clients gain access to the broader Harambee ecosystem &mdash; including educational resources, community events, webinars, and future opportunities aligned with our mission of intergenerational wealth creation for the African Diaspora.
          </p>
          <div className="inline-flex items-start gap-3 bg-white/8 border border-white/15 rounded-lg px-5 py-3 text-left">
            <div className="w-4 h-4 flex items-center justify-center flex-shrink-0 mt-0.5">
              <i className="ri-information-line text-[#C9A961] text-sm" />
            </div>
            <p className="text-white/45 text-xs leading-relaxed">
              Harambee Global Ventures provides educational and advisory services only. We do not manage funds or guarantee financial outcomes. All investment decisions remain the responsibility of the individual.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
